import Link from "next/link";
import { Button } from "@/components/ui/button";

interface BlogCardProps {
  slug: string;
  frontMatter: {
    title?: string;
    description?: string;
    date?: string;
    image?: string;
    category?: string;
  };
}

export default function BlogCard({ slug, frontMatter }: BlogCardProps) {
  const formattedDate = frontMatter.date
    ? new Date(frontMatter.date).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "";

  const dateDisplay = formattedDate.toLowerCase();

  return (
    <article className="border border-zinc-200/80 dark:border-zinc-700/50 rounded-lg p-4">
      <div className="flex flex-col gap-3">
        <Link href={`/blog/${slug}`} className="group">
          <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100 group-hover:text-zinc-700 dark:group-hover:text-zinc-300 transition-colors">
            {frontMatter.title}
          </h2>

          <div className="flex items-center gap-1 text-xs text-zinc-500 dark:text-zinc-400 my-2">
            {frontMatter.category ? (
              <>
                <span className="">{frontMatter.category}</span>
                <span> — </span>
              </>
            ) : null}
            <time>{dateDisplay}</time>
          </div>

          {frontMatter.description && (
            <p className="text-sm text-zinc-600 dark:text-zinc-400 leading-relaxed line-clamp-2">
              {frontMatter.description}
            </p>
          )}
        </Link>

        <div className="pt-2">
          <Button
            as="link"
            href={`/blog/${slug}`}
            variant="default"
            size="sm"
            className="px-2 h-8"
          >
            Read More
          </Button>
        </div>
      </div>
    </article>
  );
}
